(function() {
    var headerIdentifierElContentTpl = [
        '<tpl if="alias">',
            '<span class="sa-quick-report-header-alias">{alias:htmlEncode}</span>',
            '<span class="sa-quick-report-header-aliased-name"> [{name:htmlEncode}]</span>',
        '<tpl else>',
            '<span class="sa-quick-report-header-name">{name:htmlEncode}</span>',
        '</tpl>'
    ];

    Ext.define('SA.view.quickreport.QuickReportGridTpl', {
        singleton: true,

        tpl: [
            '<div class="sa-quick-report-first-cell-mask"></div>',
            '<div class="sa-quick-report-header-scrollbar-cap"></div>',
            '<div class="sa-quick-report-header">',
                '<tpl for="headerItems">',
                    '<div class="sa-quick-report-header-cell" data-location-series="{locationSeries}">',
                        '<div class="sa-quick-report-header-location-identifier" data-location-series="{locationSeries}">',
                            headerIdentifierElContentTpl,
                        '</div>',
                        '<div class="sa-quick-report-header-location-type">{type}</div>',
                    '</div>',
                '</tpl>',
            '</div>',
            '<div class="sa-quick-report-first-col">',
                '<div class="sa-quick-report-first-col-sections">',
                    '<tpl for="firstColSections">',
                        '<div class="sa-quick-report-first-col-section">',
                            '<div class="sa-quick-report-first-col-row sa-quick-report-first-col-section-header">{header}</div>',
                            '<tpl for="attributeTuples">',
                                '<div class="sa-quick-report-first-col-row sa-quick-report-first-col-data-row"',
                                    ' data-attributes="{[values.attributes.join(\' \').trim()]}"',
                                '>',
                                    '{label}',
                                    '<div class="sa-quick-report-first-col-add-attributes-button-wrap">',
                                        '<span class="sa-quick-report-first-col-add-attributes-button" title="Add Variable(s) to Project">',
                                            '<svg class="sa-quick-report-first-col-add-attributes-button-svg">',
                                                '<use href="#sa-icon-add"></use>',
                                            '</svg>',
                                        '</span>',
                                    '</div>',
                                '</div>',
                            '</tpl>',
                            '<tpl if="xindex !== xcount">',
                                '<div class="sa-quick-report-first-col-row sa-quick-report-first-col-section-footer"></div>',
                            '</tpl>',
                        '</div>',
                    '</tpl>',
                '</div>',
                '<div class="sa-quick-report-first-col-scrollbar-cap"></div>',
            '</div>',
            '<div class="sa-quick-report-body-wrap">',
                '<div class="sa-quick-report-body">',
                    '<tpl for="bodyColumns">',
                        '<div class="sa-quick-report-body-column" data-location-series="{locationSeries}">',
                            '<tpl for="sections">',
                                '<tpl if="hasHeaders">',
                                    '<div class="sa-quick-report-body-row sa-quick-report-body-header">',
                                        '<div class="sa-quick-report-body-cell-left">{headerLeft}</div>',
                                        '<div class="sa-quick-report-body-cell-right">{headerRight}</div>',
                                    '</div>',
                                '<tpl else>',
                                    '<div class="sa-quick-report-body-row sa-quick-report-body-header-cell"></div>',
                                '</tpl>',
                                '<tpl for="rows">',
                                    '<div class="sa-quick-report-body-row sa-quick-report-body-cell-pair">',
                                        '<tpl for="cellPairs">',
                                            '<div class="<tpl if="attribute">sa-quick-report-body-value-cell</tpl>',
                                                    '<tpl if="isAmount"> sa-quick-report-body-cell-left',
                                                    '<tpl else> sa-quick-report-body-cell-right',
                                                    '</tpl>"',
                                                ' data-attribute="{attribute}"',
                                                ' data-location-series="{locationSeries}"',
                                            '>',
                                                '{formattedValue}',
                                            '</div>',
                                        '</tpl>',
                                    '</div>',
                                '</tpl>',
                                '<tpl if="xindex !== xcount">',
                                    '<div class="sa-quick-report-body-row sa-quick-report-body-footer-cell"></div>',
                                '</tpl>',
                            '</tpl>',
                        '</div>',
                    '</tpl>',
                '</div>',
            '</div>'
        ],

        get() {
            return new Ext.XTemplate(Ext.Array.flatten(this.tpl));
        },

        getHeaderIdentifierElContentTpl() {
            return new Ext.XTemplate(headerIdentifierElContentTpl);
        }
    });
})();